import React from 'react'
import { motion } from 'framer-motion'
import { RichText } from '../../v2/components/RichText'

export default function SubmittedState({
  content,
  className,
}: {
  content: any
  className?: string
}) {
  const stateDiv = React.useRef(null)
  const scrollToBtn = React.useRef(null)
  React.useEffect(() => {
    if (scrollToBtn && scrollToBtn.current) {
      //@ts-ignore
      scrollToBtn.current.click()
    }
  }, [])
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      ref={stateDiv}
      className={`bg-accent-1 p-8 ${className}`}
    >
      <RichText content={content} />
    </motion.div>
  )
}
